import React from "react";
import injectSheet from "react-jss";
import { getUrlWithImgixParams } from "../../lib/player/src/TextureManager.js";

class TourCanvasBackground extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      background: "",
      transitioningBackground: "",
      opacity: 0,
      transitioning: false,
      nextBackground: null,
    };
  }

  componentDidMount() {
    this.switchBackground(this.props.background);
  }

  componentDidUpdate() {
    if (this.last === this.props.background) return;

    this.last = this.props.background;

    if (this.state.transitioning) {
      if (this.state.nextBackground === null) {
        // If no next background, then make sure we're not already transitioning to this
        if (this.props.background !== this.state.transitioningBackground) {
          this.switchBackground(this.props.background);
        }
      } else if (this.state.nextBackground !== this.props.background) {
        // If the next background isn't this background,
        // then check if the transitioning background is this one.
        if (this.state.transitioningBackground === this.props.background) {
          // We are already transitioning to the new background,
          // So just stop it going to next one.
          this.setState({ nextBackground: null });
        } else {
          // We have to queue background
          this.switchBackground(this.props.background);
        }
      }
    } else {
      // Ensure isn't already there, or will be there soon
      if (this.props.background !== this.state.background) {
        if (this.props.background !== this.state.nextBackground) {
          this.switchBackground(this.props.background);
        }
      }
    }
  }

  switchBackground(background) {
    // Check it's a valid background
    // If not, transition to empty
    if (background === false) return;

    let newBackground = background;
    if (newBackground === undefined || newBackground === false) {
      newBackground = "";
    }

    // If already transitioning, then move to next background
    if (this.state.transitioning) {
      if (this.state.transitioningBackground !== background) {
        this.setState({
          nextBackground: newBackground,
        });
      }
    } else {
      this.setState({
        transitioningBackground: newBackground,
      });

      this.startTransition(newBackground);
    }
  }

  startTransition(newBackground) {
    this.setState({ transitioning: true, opacity: 0 });

    // Preload the image so the fade works properly
    this.image = new Image();
    this.image.onload = () => {
      this.setState({ opacity: 0 });

      // This forces the next image to render
      this.timeout1 = setTimeout(() => {
        this.setState({ opacity: 1 });

        this.timeout2 = setTimeout(() => {
          // If there's a next background, then move on
          if (this.state.nextBackground !== null) {
            const next = this.state.nextBackground;
            this.setState({
              background: this.state.transitioningBackground,
              transitioningBackground: this.state.nextBackground,
              transitioning: false,
              nextBackground: null,
            });

            this.startTransition(next);
          } else {
            // Otherwise, we're done
            this.setState({
              background: this.state.transitioningBackground,
              transitioningBackground: "",
              transitioning: false,
            });
          }
        }, 2000);
      }, 500);
    };

    if (typeof newBackground === 'object') {
      newBackground = newBackground.toString();
    }

    if (newBackground !== undefined && (newBackground.includes("imgix") || newBackground.includes("imgo"))) {
      newBackground = getUrlWithImgixParams(newBackground, {
        "max-w": 5000
      });
    }

    this.image.src = newBackground;
  }

  componentWillUnmount() {
    if (this.timeout1) clearTimeout(this.timeout1);
    if (this.timeout2) clearTimeout(this.timeout2);
    if (this.image) this.image.onload = () => {};
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div
          className={classes.image}
          style={{ backgroundImage: `url(${this.state.background})` }}
        />
        {this.state.transitioning && (
          <div
            className={classes.image}
            style={{
              backgroundImage: `url(${this.state.transitioningBackground})`,
              opacity: this.state.opacity,
            }}
          />
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0.8,
  },
  image: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 1,
    backgroundSize: "cover",
    transitionProperty: "opacity",
    transitionDuration: "2s",
  },
};

export default injectSheet(styles)(TourCanvasBackground);
